import {
    Breakpoints,
    styled,
    Text,
    TextTag,
    TokenTextColor,
} from '@volkswagen-onehub/components-core'
import React from 'react'
import {useTranslation} from 'react-i18next'
import {
    SingleEquipment,
    SinglePromotionEquipment,
} from '../../../types/singleModelInterface'

const EquipmentsList = styled.ul`
    padding: 0;
    margin-bottom: 0;
    list-style: none;

    li {
        display: flex;
        align-items: center;
        margin-top: 0;
        margin-bottom: 20px;
    }
`

const EquipmentsListItem = styled.li`
    display: flex;
    align-items: center;
    margin-top: 0;
    margin-bottom: 20px;
    font-size: 14px;

    @media only screen and (min-width: ${Breakpoints.b960}px) {
        font-size: 16px;
    }
`

const EquipmentsListTitle = styled(Text)`
    font-size: 16px;

    @media only screen and (min-width: ${Breakpoints.b960}px) {
        font-size: 18px;
    }
`

const EquipmentsListIcon = styled(Text)`
    margin-right: 10px;
`

const EquipmentsGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 60px;

    @media only screen and (min-width: ${Breakpoints.b960}px) {
        grid-template-columns: repeat(2, 1fr);
        gap: 40px;
    }
`

const EquipmentsImage = styled.img`
    max-width: 100%;
    height: auto;
    display: block;
`

interface Equipment {
    hasImage: boolean
    image: string
    imageAlt: string
    equipment: SingleEquipment[] | SinglePromotionEquipment[]
}

export default function StandardEquipment(props: Equipment): React.JSX.Element {
    const {t} = useTranslation('app')

    return (
        <EquipmentsGrid>
            <div>
                <EquipmentsListTitle tag={TextTag.h3} bold={true}>
                    {t('singlePage.equipments.title')}
                </EquipmentsListTitle>

                <EquipmentsList>
                    {props.equipment.map(
                        (
                            equipment:
                                | SingleEquipment
                                | SinglePromotionEquipment
                        ) => (
                            <EquipmentsListItem key={equipment.id}>
                                <EquipmentsListIcon
                                    tag={TextTag.span}
                                    bold
                                    color={TokenTextColor.primary}
                                >
                                    &mdash;
                                </EquipmentsListIcon>
                                <span>{equipment.name}</span>
                            </EquipmentsListItem>
                        )
                    )}
                </EquipmentsList>
            </div>

            {props.hasImage && props.image ? (
                <div>
                    <EquipmentsImage src={props.image} alt={props.imageAlt} />
                </div>
            ) : undefined}
        </EquipmentsGrid>
    )
}
